import loadable from "@loadable/component";
import { useEffect, useState } from "react";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
import moment from "moment";

const CreateOrderComponent = loadable(
  () => import("../../components/Consignment/CreateConsignment")
);

const CreateConsignment = () => {
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false);
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false);
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const [createData, setCreateData] = useState(null);
  const [create_print, setCreate_Print] = useState(false);
  const [formShouldReset, setFormShouldReset] = useState(false);
  const [resetAndAddForm, setResetAndAddForm] = useState(false);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
    navigateURL: "",
  });

  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const handleLabelPrintDownload = async () => {
    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: [selectedOrder],
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };

  const handleOrderReceiptDownload = async () => {
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: [selectedOrder],
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };
  const transformPackageTypeToId = (data: any[]) => {
    return data?.map((item) => ({
      ...item,
      calculated_by: item.calculated_by?.id,
      package_type: item.package_type.id,
    }));
  };
  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.ORDER}`;

    const formattedArray = values?.extra_charges
      ? Object.entries(values.extra_charges)
          .filter(([_, value]) => value !== "" && value !== null && value !== 0)
          .map(([key, value]) => ({
            name: key,
            charge: value,
          }))
      : null;

    const transformedData = transformPackageTypeToId(values?.order_items);
    let formData = {
      ...values,
      order_items: transformedData,
      sender_phone_number:
        values?.sender_phone_number?.length === 10
          ? `+977${values?.sender_phone_number}`
          : values?.sender_phone_number
          ? values?.sender_phone_number
          : null,
      receiver_phone_number:
        values?.receiver_phone_number?.length === 10
          ? `+977${values?.receiver_phone_number}`
          : values?.receiver_phone_number
          ? values?.receiver_phone_number
          : null,
      extra_charges: formattedArray,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenPrintPopup(true);
        setSelectedOrder(res?.data?.id);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-4 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Consignment
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <CreateOrderComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          defaultBranch={profile?.default_branch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          profile={profile}
          isPrintLoading={isPrintLoading}
          handleLabelPrintDownload={handleLabelPrintDownload}
          handleOrderReceiptDownload={handleOrderReceiptDownload}
          setCreate_Print={setCreate_Print}
          values={createData}
          shouldReset={formShouldReset}
          setShouldReset={setFormShouldReset}
          setResetAndAddForm={setResetAndAddForm}
          resetAndAddForm={resetAndAddForm}
        />
      )}
    </>
  );
};

export default CreateConsignment;
